import axios from "axios";
import { getData, sendData } from "../Utilities/Encryption";

// const HOST = 'https://ecspreprod.easypay.co.in:8080/web-common/on-common/';
const HOST = process.env.REACT_APP_PORTAL_URL;
const DIRECTHOST = process.env.REACT_APP_PORTAL_URL_DIRECT;
const NO_ENCRYPTION_HOST = "";

export const JsonLogFormatter = (obj) => {
  return JSON.stringify(obj, null, 2);
};

export const HTTPS = async (URL, PAYLOAD, encryption = true) => {
  if (encryption) {
    try {
      const formData = new FormData();
      formData.append("request", sendData(PAYLOAD));
      const API = HOST + URL;

      const response = await axios.post(API, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const parsedData = JSON.parse(getData(response.data));
      return parsedData;
    } catch (error) {
      throw error;
    }
  } else {
    try {
      const APIURL = HOST + URL;
      const response = await axios.post(APIURL, PAYLOAD, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export const HTTPSDIRECT = async (URL, PAYLOAD) => {
  try {
    const API = DIRECTHOST + URL;

    const response = await axios.post(API, PAYLOAD, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;

  } catch (error) {
    throw error;
  }
};

const getAPIName = (url = "") => {
  return url?.slice(url?.lastIndexOf("/") + 1);
};
